/**
 * enterprise-search-fix.js
 *
 * Fix per la search bar Enterprise (custom) che usa il <predictive-search>
 * di Dawn. Risolve 2 problemi:
 *
 * 1) `getResultsMaxHeight()` di Dawn cerca `.section-header` che non esiste nel
 *    tema custom → restituisce NaN → inline style `max-height: NaNpx` invalido,
 *    può interferire con lo stato del dropdown.
 *
 * 2) Race condition: dopo il primo render, lo `searchTerm` interno può restare
 *    disallineato dal valore reale dell'input se l'utente modifica la stringa
 *    rapidamente. Sintomo: il dropdown non aggiorna i risultati finché non
 *    si clicca fuori e si rientra (`onFocus` rileva il disallineamento e
 *    richiama `onChange`).
 *
 * Il fix:
 * - Patcha `getResultsMaxHeight()` per ritornare un fallback sensato.
 * - Aggiunge un "safety net": un secondo input listener che si attiva ~50ms
 *   dopo il debounce originale e re-triggera `onChange()` se rileva
 *   disallineamento input.value vs searchTerm.
 *
 * Caricato dopo predictive-search.js in layout/theme.liquid.
 */
(function () {
  'use strict';

  function patchGetResultsMaxHeight() {
    if (!window.customElements) return;
    const ctor = window.customElements.get('predictive-search');
    if (!ctor || !ctor.prototype) return;

    ctor.prototype.getResultsMaxHeight = function () {
      // Cerca prima un header standard, poi quello custom enterprise
      const headerEl =
        document.querySelector('.section-header') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('header.header') ||
        document.querySelector('header');
      const headerBottom = headerEl
        ? headerEl.getBoundingClientRect().bottom
        : 0;
      const computed = window.innerHeight - headerBottom - 20; // 20px buffer
      this.resultsMaxHeight =
        !isFinite(computed) || computed < 200 ? Math.max(window.innerHeight * 0.7, 300) : computed;
      return this.resultsMaxHeight;
    };
  }

  function attachSafetyNet() {
    const psList = document.querySelectorAll('predictive-search.search-enterprise');
    psList.forEach((ps) => {
      const input = ps.querySelector('input[type="search"]');
      if (!input) return;

      let timer;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const currentValue = input.value.trim();
          // Se l'input ha contenuto MA il searchTerm interno è disallineato:
          // force re-trigger di onChange. Mantiene il sistema "in sync".
          if (currentValue.length >= 2 && ps.searchTerm !== currentValue) {
            // Reset interno per forzare il fetch (newTerm non startsWith '')
            // così onChange ricalcola e fa fetch fresco
            ps.searchTerm = '';
            if (typeof ps.onChange === 'function') {
              ps.onChange();
            }
          }
        }, 380); // 80ms dopo il debounce originale (300ms), così se quello funziona già non interferisce
      });
    });
  }

  function init() {
    patchGetResultsMaxHeight();
    attachSafetyNet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Già caricato: aspetta un tick per essere sicuro che predictive-search.js
    // abbia registrato il custom element
    setTimeout(init, 50);
  }
})();
